import { gql, useQuery } from '@apollo/client';
import { UtexBalance } from './index.types';

const query = gql`
  query UtexBalance {
    currentUser {
      utexBalance(currency: "USD") {
        totalHumanReadable {
          currency {
            code
            fractionDigits
          }
          value
        }
      }
    }
  }
`;

export const useUtexBalance = () => {
  const { data } = useQuery<UtexBalance>(query);

  return {
    balance: data?.currentUser?.utexBalance?.totalHumanReadable,
  };
};
